export enum NaoNIFENUM {

  NAOINFORMADO = "Não informado na nota de origem",
  DISPENSADO = "Dispensado do NIF",
  NAOEXIGENCIA = "Não exigência do NIF"

}
